module.exports = __webpack_public_path__ + "img/86.3ca66d33.jpg";